import * as i0 from '@angular/core';
import { InjectionToken, inject, ElementRef, Renderer2, Directive } from '@angular/core';
const APP_VERSION_OPTIONS_TOKEN = new InjectionToken('[ngxAppVersion] Options');
const provideAppVersion = options => {
  return {
    provide: APP_VERSION_OPTIONS_TOKEN,
    useValue: {
      version: options.version
    }
  };
};

/**
 * @returns app version
 */
let NgxAppVersionDirective = /*#__PURE__*/(() => {
  class NgxAppVersionDirective {
    constructor() {
      this.options = inject(APP_VERSION_OPTIONS_TOKEN);
      this.element = inject(ElementRef);
      this.renderer = inject(Renderer2);
    }
    ngOnInit() {
      this.renderer.setAttribute(this.element.nativeElement, 'app-version', this.options.version);
    }
    static {
      this.ɵfac = function NgxAppVersionDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgxAppVersionDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgxAppVersionDirective,
        selectors: [["", "ngxAppVersion", ""]],
        standalone: true
      });
    }
  }
  return NgxAppVersionDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-app-version
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APP_VERSION_OPTIONS_TOKEN, NgxAppVersionDirective, provideAppVersion };
